<template>
  <div class="modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Logout</h5>
          <button type="button" class="btn btn-sm remove-shadow" v-on:click="closeModal">
          <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6>Are you sure you would like to logout ?</h6>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" v-on:click="closeModal">Cancel</button>
          <button type="button" class="btn btn-danger" v-on:click="confirmModal">Logout</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ConfirmModal',
   data(){
      return {
        //
      }
    },
    methods: {
      closeModal() {
        this.$emit('close-modal');
      },
      confirmModal() {
        this.$emit('confirm-modal');
      }
    },
  };
</script>
<style scoped>
  .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
  }

  .remove-shadow {
    box-shadow: 0 0px 0px 0px rgb(0 0 0 / 11%), 0 0px 0px 0px rgb(0 0 0 / 7%) !important;
  }
</style>